import { Component } from '@angular/core';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-sales-products-tab',
  imports: [APITableComponent, TabLayoutComponent],
  providers: [
    { provide: TabComponent, useExisting: SalesProductsTabComponent },
  ],
  templateUrl: './sales-products-tab.component.html',
})
export class SalesProductsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Products');

  readonly endpoint = '/sale/tables/product';
  readonly hasChartView = false;
  readonly skipDateRange = false;
  readonly defaultSort: Record<string, 'asc' | 'desc'> = {
    Product: 'desc',
  };

  override async main(): Promise<void> {}
}
